// Central registry of all languages KARS supports.
//
// `code`       — vue-i18n locale key (also persisted in localStorage)
// `flag`       — flag-icons country code (ISO 3166-1 alpha-2, lower-case)
// `nativeName` — language name in its own language (what users recognise)
// `englishName`— stable internal/debug label
//
// Order matters: it is the order shown in the language switcher. German
// stays first (default), the rest follow the order requested in the issue.

export interface LanguageMeta {
  code: string;
  flag: string;
  nativeName: string;
  englishName: string;
}

export const SUPPORTED_LANGUAGES: LanguageMeta[] = [
  { code: "de", flag: "de", nativeName: "Deutsch", englishName: "German" },
  { code: "en", flag: "gb", nativeName: "English", englishName: "English" },
  { code: "es", flag: "es", nativeName: "Español", englishName: "Spanish" },
  { code: "ru", flag: "ru", nativeName: "Русский", englishName: "Russian" },
  { code: "uk", flag: "ua", nativeName: "Українська", englishName: "Ukrainian" },
  { code: "hu", flag: "hu", nativeName: "Magyar", englishName: "Hungarian" },
  { code: "tr", flag: "tr", nativeName: "Türkçe", englishName: "Turkish" },
  { code: "ro", flag: "ro", nativeName: "Română", englishName: "Romanian" },
  { code: "fr", flag: "fr", nativeName: "Français", englishName: "French" },
  { code: "pl", flag: "pl", nativeName: "Polski", englishName: "Polish" },
  { code: "cs", flag: "cz", nativeName: "Čeština", englishName: "Czech" },
  { code: "it", flag: "it", nativeName: "Italiano", englishName: "Italian" },
  { code: "hr", flag: "hr", nativeName: "Hrvatski", englishName: "Croatian" },
  { code: "bs", flag: "ba", nativeName: "Bosanski", englishName: "Bosnian" },
];

export const DEFAULT_LANGUAGE = "de";

export const SUPPORTED_LANGUAGE_CODES = SUPPORTED_LANGUAGES.map((l) => l.code);

export function getLanguageMeta(code: string): LanguageMeta {
  return (
    SUPPORTED_LANGUAGES.find((l) => l.code === code) ??
    SUPPORTED_LANGUAGES[0]!
  );
}
